// Compute the initial set of selected vendor IDs the UI should show.
//
// A property is rendered only if its VendorId appears in selectedVendors
// (see Configure.js / Category.js / Group.js). The set must therefore
// cover every VendorId that any property in the catalog actually uses.
//
// Sources, in order:
//   1. vendorsPresentation.json (the "Map" field on each entry)
//   2. Every component's VendorIds
//   3. Every property's VendorId — needed because individual properties
//      may carry a per-property VendorIds override that the component
//      does not declare (e.g. countrynamestranslated on Location's
//      CountryNames*Translated). Without this step those properties are
//      silently filtered out by the UI.
export function computeSelectedVendors(vendors, components, properties) {
    var result = (vendors || []).map(function (v) { return v.Map || v.map; });

    (components || []).forEach(function (component) {
        (component.VendorIds || []).forEach(function (vid) {
            if (result.indexOf(vid) === -1) {
                result.push(vid);
            }
        });
    });

    (properties || []).forEach(function (property) {
        var vid = property.VendorId;
        if (vid && result.indexOf(vid) === -1) {
            result.push(vid);
        }
    });

    return result;
}
